<template>
  <Skeleton>
    <template v-for="(_, slotName) in $slots" #[slotName]="slotProps">
      <slot :name="slotName" v-bind="slotProps ?? {}" />
    </template>
  </Skeleton>
</template>

<script setup lang="ts">
import type { SkeletonEmits, SkeletonProps } from "primevue";

import { Skeleton } from "primevue";

defineProps</* @vue-ignore */ SkeletonProps>();
defineEmits</* @vue-ignore */ SkeletonEmits>();
</script>

<style lang="postcss">
.p-skeleton {
  @apply animate-shimmer overflow-hidden rounded-md bg-surface-200;

  &-circle {
    @apply rounded-full;
  }

  &-animation-none::after {
    @apply animate-none;
  }
}
</style>
